<template>
  <div class="add-payment-container">
    <Lending
      ref="commonForm"
      :investId="investId"
      :isDetail="false"
      :investBatch="investBatch"
      :investData="formData"
      @getLastMoney="getLastMoney"
      @getMoneyType="getMoneyType"
    />

    <Accessory
      v-if="uploadPermissionNameOne != ''&&(investmentLoanFormData.projectInfoId||formData.projectInfoId)"
      :idname="uploadPermissionNameTwo"
      :fileMenuUrlname="uploadPermissionNameOne"
      :projectid="investmentLoanFormData.projectInfoId||formData.projectInfoId"
      :dynamicId="virtualId"
      :upload="true"
      :permissionList="permissionList"
      :isPermission="true"
    />

    <InfoContainer
      :infoTitle="commentConfig['infoTitle']"
      :contentConfig="commentConfig['infoContent']"
    >
      <template #commentInfo>
        <!-- 会签意见区 -->
        <CommentBlock
          ref="commentBlock"
          :id="virtualId"
          @fileChange="fileChange"
        />
      </template>
    </InfoContainer>

    <div style="width: 100%; height: 40px"></div>
    <div
      class="bottom-container"
      v-if="moneyType==1||lastMoney>0
      "
    >
      <div class="button-container">
        <el-button type="primary" @click="savePage(false)">保存</el-button>
        <el-button type="primary" plain @click="savePage(true)" v-if="!formData.flowableId"
          >发起流程</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Accessory from "@/components/accessoriesother/accessoryFactor";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import InfoContainer from "@/components/infoContainer/infoContainer";
import Lending from "./components/lending";
import workFlow from "@/mixins/workFlow";
import { lendingDetail, addLending } from "@/api/factoring/factoring";
export default {
  name: "AddPrePayment",
  mixins: [workFlow],
  data() {
    return {
      formData: {},
      processKey: "bl_paymentPlan",
      detailFormUrl:
        "/factoring/paymentPlanAdjustManage/paymentPlanAdjustDetail",
      virtualId: "",
      investId: "",
      investmentLoanFormData: {
        projectInfoId:''
      },
      investBatch: "",
      commentConfig: {
        infoTitle: "会签意见区",
        infoContent: [
          {
            title: "",
            prop: "commentInfo",
          },
        ],
      },
      lastMoney:0,
      moneyType:''
    };
  },
  components: {
    Lending,
    Accessory,
    CommentBlock,
    InfoContainer,
  },
  mounted() {
    this.startPrepayment();
  },
  activated() {
    this.startPrepayment();
  },
  methods: {
    getLastMoney(data){
       this.lastMoney=data
    },
    getMoneyType(data){
       this.moneyType=data
    },
    async startPrepayment() {
      if (this.$route.params.id && this.$route.params.id != "0") {
        this.virtualId = this.$route.params.id;
        this.queryCompleteDetail(this.$route.params.id);
      } else {
        this.virtualId = await this.getVirtualID();
        this.investmentLoanFormData = JSON.parse(
          window.sessionStorage.getItem("investmentLoanProjectInfo")
        );
        
        this.investId = this.investmentLoanFormData.id;
        this.investBatch = this.investmentLoanFormData.investBatch;
        // this.queryAddLandingDetail();
      }
      this.getBasicConfigData();
    },
    // async queryAddLandingDetail() {
    //   let res = await addLendingDetail({ investId: this.investId });
    //   this.formData = res.data.data;
    //   // 处理内扣合计金额 本笔应实付金额
    //   this.formData.presentCostSum = 0;
    //   this.formData.actuallPayment = 0;
    //   this.formData.innerList.map((item) => {
    //     item.outlayAmountStr = `${this.getMoney(Number(item.outlayAmount))}元`;
    //     item.innerPaymentStr = `${this.getMoney(Number(item.innerPayment))}元`;
    //   });
    // },
    async queryCompleteDetail(id) {
      let res = await lendingDetail({ id });
      if (res.data.code == 200) {
        this.formData = res.data.data;
       
        this.investId = this.formData.investId;
        this.investBatch = this.formData.investBatch;
      }
    },

    async getBasicConfigData() {
      this.processDefinedId = await this.userQueryProcessDefinedId(
        this.processKey
      );
      // 获取当前流程文件上传列表权限 permissionList
      this.permissionList = await this.queryTaskUploadDetail(
        this.processDefinedId,
        "",
        true
      );
      // 设置流程表单路径
      this.queryProcessFormDetail(this.processDefinedId);
    },

    // 会签意见区附件设置
    fileChange(fileList) {
      let self = this;
      if (fileList.length > 0) {
        this.attchmentList = [];
        fileList.map((item) => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link,
          });
        });
      }
    },

    async savePage(startProcess) {
      let validRes = await this.$refs.commonForm.validFormData();

      if (validRes) {
        this.submitForm(startProcess);
      }
    },

    async submitForm(startProcess) {
      let msg = this.$route.params.id ? "修改成功" : "新增成功";

      let processInsId = "";
      let lendingForm = this.$refs.commonForm.lendingForm;
      let newArray = [];
      lendingForm.innerList.map((item) => {
        newArray.push({
          // paymentId: this.investId,
          outlayId: item.otherOutlayId,
          innerMoney: item.presentCost,
        });
      });
      let params = {
        investId: this.investId,
        collectionBankId: lendingForm.collectionBankId,
        custId: lendingForm.custBankBl.custId,
        moneyType: lendingForm.moneyType,
        investMoney: lendingForm.investMoney,
        payType: lendingForm.payType,
        remarks: lendingForm.otherCondition,
        planPayDate: lendingForm.planPayDate,
        investShouldMoney: lendingForm.actuallPayment,
      };
      if (lendingForm.moneyType == 0) {
        params.paymentOutlays = newArray;
      } else {
        params.depositAmounts = lendingForm.depositAmounts
          ? lendingForm.depositAmounts
          : [];
      }
      params.id = lendingForm.id ? lendingForm.id : this.virtualId;

      if (startProcess) {
        // 若存在会签意见附件 带入attchment字段
        let redirectInfo = {
          url: this.detailFormUrl,
          id: params.id,
        };
        let processParams = {
          detailFormUrl: JSON.stringify(redirectInfo),
          processId: this.processDefinedId,
          comment: this.$refs.commentBlock.$data.opinionContent,
          attachmentList: this.attchmentList,
        };
        processInsId = await this.startWorkFlowProcess(processParams);
        // if(processInsId != '') params.flowableId = processInsId
      }
      if (processInsId != "") params.flowableId = processInsId;
      
      let res = await addLending(params);
      if (res.data.code == 200) {
        window.sessionStorage.removeItem("investmentLoanProjectInfo");
        this.$router.push({
          path: `/factoring/paymentPlanAdjustManage/paymentPlanAdjustDetail/${params.id}`,
        });
        // 跳转到详情页
        this.$message({
          message: msg,
          type: "success",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.add-payment-container {
  padding: 10px 15px !important;
  .bottom-container {
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);
    .button-container {
      width: 78%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>